<template>
  <div class="tag-wrapper">
    <b-dropdown
      scrollable
      v-model="selectedMetric"
      class="modelportfolio-picker tags"
    >
      <template #trigger>
        <b-button
          v-bind:label="screen_set.name"
          icon-pack="fas"
          class="button is-small"
          icon-right="caret-down" />
      </template>
      <b-dropdown-item>
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <strong>{{ screen_set.metrics.filter(metric => !metric.metaphor).length }} metrics</strong>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item" v-if="!screen_set.is_template && !screen_set.internal_identifier && editEnabled">
              <a href="#_" v-on:click="$emit('edit')">Edit</a>
            </div>

        <div class="level-item" v-if="allowDelete">
            <b-tooltip label="Delete"
                position="is-bottom">
                
                    <b-button
                        icon-pack="fas"
                        class="button is-small"
                        icon-right="trash"
                        @click="deleteScreenSet(screen_set.id)"
                    />
                
            </b-tooltip>
        </div>

          </div>
        </div>
      </b-dropdown-item>
      <b-dropdown-item
        v-for="(metric, index) in screen_set.metrics"
        v-bind:key="index"
        v-if="metric.details"
        v-on:click="selectMetric(metric)"
      >
        <span v-bind:class="['tag', 'is-light', 'is-'+metric.details.subcategory[0].esgissue.slug]">{{ metric.details.name }}</span >
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  import eventBus from '@frontend/shared/EventBus.js';
  import { apiFetch } from '../../../api/api';

  export default {
    data() {
      return {
        selectedMetric: null
      }
    },
    props: {
      screen_set: Object,
      editEnabled: {
        type: Boolean,
        default: false,
      },
      callback: Function,
      allowDelete: false
    },
    components: {},
    methods: {
      selectMetric: function(metric) {
        // TODO: This is redundant but not worth cleaning up until a wider effort
        // to replace some of the more brittle event listeners with the eventbus

        this.$root.$emit('screen-selected', metric.details);
        eventBus.$emit('reveal-screen-detail-pane', metric.details);

        // TODO: This is the actual event that should be emitted in the new-style
        // component-namespaced style, should clean up listeners to the above events.
        eventBus.$emit('ValueTag:metric-selected', metric.details);
      },
      deleteScreenSet: function(screenSetId) {
        apiFetch(`/api/v1/screen_sets/${screenSetId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.$root.$data.csrfToken,
          }
        }).then((response) => {
          if (response.status == 204) {
              this.callback(screenSetId);
                this.$buefy.toast.open({
                    message: 'Values set deleted!',
                    type: 'is-success'
                })
          }
          else {
            response.json().then((data) => {
              alert('There was an error deleting this Values set, please try again.');
            });
          }
        });
      }
    },
    computed: {},
    created: function() {console.log(this.screen_set)},
  }
</script>

<style lang="scss" scoped>
.tag-wrapper {
  margin: 0.75em;
}
.tag {
  text-align: left;
  display: inline-block !important;
  height: auto !important;
  white-space: unset !important;
  width: 100%
}
</style>
